import NotificationIcon from './notification-icon';

export default NotificationIcon;